import { render } from "./ApiHeader.vue?vue&type=template&id=8c7f0532&ts=true"
import script from "./ApiHeader.vue?vue&type=script&lang=ts"
export * from "./ApiHeader.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__